import BaseProxy from './Base';

class FormationProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('formation', parameters, 'api/v1');
  }

  create(item) {
    return this.submit('put', `/${this.endpoint}`, item);
  }

  delete(id) {
    return this.submit('delete', `/${this.endpoint}/${id}`);
  }

  getItems() {
    return this.load();
  }

  update(id, item) {
    return this.submit('put', `/${this.endpoint}/${id}`, item);
  }
}

export default FormationProxy;
